<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { AlertDialogCancelProps } from 'reka-ui';
  import { AlertDialogCancel } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import type { ButtonVariants } from '@ui/components/button';
  import { buttonVariants } from '@ui/components/button';
  import { cn } from '@ui/utils/utils';

  const props = defineProps<
    AlertDialogCancelProps & { class?: HTMLAttributes['class']; size?: ButtonVariants['size'] }
  >();

  const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <AlertDialogCancel
    v-bind="delegatedProps"
    :class="cn(buttonVariants({ variant: 'outline', size }), 'mt-2 sm:mt-0', props.class)"
  >
    <slot />
  </AlertDialogCancel>
</template>
